import { useRef } from 'react'
import { CacheProvider } from '@chakra-ui/next-js'
import {
  ChakraProvider,
  ChakraProviderProps,
  createStandaloneToast,
} from '@chakra-ui/react'
import { getColor as getColorBase } from '@chakra-ui/theme-tools'
import { Z_INDEX } from 'constants/common'
import { theme } from './theme'
import 'graphql-voyager/dist/voyager.v1.css'
import 'prismjs/themes/prism.css'
import 'text-security/text-security.css'

/**
 * `getColor` returns value of the color defined in the theme,
 * for example:
 * @example getColor('blue.500')
 */
export const getColor = (color: string): string | undefined =>
  getColorBase(theme, color) as string | undefined

const { toast } = createStandaloneToast({ theme })
export { toast }

export const ThemeProvider = ({ children, ...rest }: ChakraProviderProps) => {
  const toastContainerElRef = useRef<HTMLDivElement>(null)
  return (
    <CacheProvider>
      <ChakraProvider
        portalZIndex={Z_INDEX.PORTAL}
        theme={theme}
        toastOptions={{
          portalProps: {
            // Setting portalZIndex causes the toast to be rendered behind the modal. This is a workaround.
            // See https://github.com/chakra-ui/chakra-ui/issues/6276
            containerRef: toastContainerElRef,
          },
        }}
        {...rest}
      >
        {children}
        <div ref={toastContainerElRef} />
      </ChakraProvider>
    </CacheProvider>
  )
}

export default theme
